import { useEffect, useState } from "react";
import { useForm } from "@inertiajs/react";
import axios from "axios";

const ModalLoginAndRegister = ({ openModal, openLogin, openRegister, openFormRegister, onClose, redirectUrl }) => {
    function setGoogleRedirect() {
        localStorage.setItem("g-redirect-url", redirectUrl ?? window.location.href);
        window.location.href = "/auth/google";
    }

    // data form login
    const {
        data: loginData,
        setData: setLoginData,
        reset: resetLogin,
        errors: loginError,
        setError: setLoginError,
        clearErrors: clearLoginError
    } = useForm({
        email: "",
        password: "",
        remember: false,
    });

    // data form register
    const {
        data: registerData,
        setData: setRegisterData,
        reset: resetRegister,
        errors: registerError,
        setError: setRegisterError,
        clearErrors: clearRegisterError
    } = useForm({
        email: "",
        name: "",
        pekerjaan: "",
        tgl_lahir: "",
        password: "",
    });

    const [isPasswordVisible, setIsPasswordVisible] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [continueTo, setContinueTo] = useState(redirectUrl ?? window.location.href);

    useEffect(() => {
        setContinueTo(redirectUrl ?? window.location.href);
    }, [redirectUrl]);

    const submitLogin = async (e) => {
        e.preventDefault();
        setIsProcessing(true);
        try {
            const res = await axios.post('/auth/login', loginData);
            if (res.data.status === 'success') {
                window.location.href = continueTo;
                handleCloseModal();
            } else {
                setLoginData(data => ({ ...data, password: '' }));
                setLoginError('message', res.data.message);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsProcessing(false);
        }
    };

    const checkEmailAvalability = async (e) => {
        e.preventDefault();
        setIsProcessing(true);
        try {
            const res = await axios.post('/auth/register/validate-email', { email: registerData.email });
            if (res.data.status === 'success') {
                openFormRegister();
                clearRegisterError();
            } else {
                setRegisterData(data => ({ ...data, email: '' }));
                setRegisterError('email', res.data.errors.email[0]);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsProcessing(false);
        }
    };

    function handleCloseModal() {
        resetRegister();
        resetLogin();
        clearLoginError();
        clearRegisterError();
        setIsProcessing(false);
        onClose();
    }

    const submitRegister = async (e) => {
        e.preventDefault();
        setIsProcessing(true);
        try {
            clearRegisterError();
            const res = await axios.post('/auth/register', registerData);
            window.location.href = continueTo;
            handleCloseModal();
        } catch (error) {
            if (error.response?.status === 422 && error.response?.data?.errors) {
                setRegisterError(error.response.data.errors);
            }
        } finally {
            setIsProcessing(false);
        }
    };

    if (openModal == 0) return null;

    // MODAL LOGIN
    if (openModal == 1) return (
        <div className="modal-login-register position-fixed w-100 h-100 top-50">
            <div className="wrapper position-fixed w-100 top-50 bg-light p-4 text-center">
                <p onClick={handleCloseModal} className="position-fixed button-close fs-2 me-3 mt-2">
                    <img className="me-1" src="/images/Icons.png" alt="close" />
                </p>
                <h4 className="mt-1 mb-4">Masuk</h4>
                <p>Belum punya akun? <a href="#" onClick={openRegister}>Daftar</a></p>
                <div className="d-flex flex-column">
                    <div className="btn-google pt-1 pb-1 mb-3">
                        <button className="btn btn-border btn-google-login" onClick={setGoogleRedirect} >
                            <img className="me-1" src="/images/icon/ic_google.png" alt="Google" /> Masuk dengan Google
                        </button>
                    </div>
                    <p className="label1 mb-2">----------------------------   atau masuk dengan   ----------------------------</p>
                </div>

                {/* FORM LOGIN */}
                <form onSubmit={submitLogin}>
                    <div className="mb-3 text-start">
                        <label className="form-label">Email</label>
                        <input type="email"
                            className="form-control"
                            value={loginData.email}
                            onChange={e => {
                                clearLoginError();
                                setLoginData('email', e.target.value);
                            }}
                            required
                            autoFocus
                        />
                    </div>
                    <div className="mb-3 text-start">
                        <label className="form-label">Password</label>
                        <div className="position-relative">
                            <input type={isPasswordVisible ? "text" : "password"}
                                className="form-control"
                                value={loginData.password}
                                onChange={e => {
                                    clearLoginError();
                                    setLoginData('password', e.target.value);
                                }}
                                required
                            />
                            <span className="img2">
                                <img src={`/images/icon/${isPasswordVisible ? "show" : "hide"}-eye.png`}
                                    onClick={() => setIsPasswordVisible(prev => !prev)}
                                    alt={`${isPasswordVisible ? "show" : "hide"} password`} />
                            </span>
                        </div>
                        {loginError.message && (
                            <p className="m-0 pt-2 text-danger" style={{ fontSize: '12px' }}>{loginError.message}</p>)
                        }
                    </div>
                    <div className="d-flex justify-content-between">
                        <div className="form-check">
                            <input type="checkbox"
                                id="remember-check"
                                className="form-check-input"
                                checked={loginData.remember}
                                onChange={e => setLoginData('remember', e.target.checked)}
                            />
                            <label htmlFor="remember-check" className="form-check-label">Ingat saya</label>
                        </div>
                        <a href='auth/password/reset' className="mt-1">Lupa password?</a>
                    </div>
                    <button className="btn-mm--primary w-100" type="submit" disabled={isProcessing}>Masuk</button>
                </form>
            </div>
        </div>
    );

    // MODAL REGISTER
    if (openModal == 2) return (
        <div className="modal-login-register position-fixed w-100 h-100 top-50">
            <div className="wrapper position-fixed w-100 top-50 bg-light p-4 text-center">
                <p onClick={handleCloseModal} className="position-fixed button-close fs-2 me-3 mt-2">
                    <img className="me-1" src="/images/Icons.png" alt="close" />
                </p>
                <h4 className="mt-1 mb-4">Daftar</h4>
                <p>Sudah punya akun? <a href="" onClick={openLogin}>Masuk</a></p>
                <div className="d-flex flex-column">
                    <div className="btn-google pt-1 pb-1 mb-3">
                        <button className="btn btn-border btn-google-login" onClick={setGoogleRedirect} >
                            <img className="me-1" src="/images/icon/ic_google.png" alt="Google" /> Masuk dengan Google
                        </button>
                    </div>
                    <p className="label1 mb-2">----------------------------   atau masuk dengan   ----------------------------</p>
                </div>

                {/* FORM CEK EMAIL */}
                <form method="GET" onSubmit={checkEmailAvalability}>
                    <div className="mb-3 text-start">
                        <label className="form-label">Email</label>
                        <input type="email"
                            className="form-control"
                            value={registerData.email}
                            onChange={e => {
                                setRegisterError('email', '');
                                setRegisterData('email', e.target.value);
                            }}
                            required
                            autoFocus
                        />
                        {registerError.email && (
                            <p className="mt-1 text-danger" style={{ fontSize: '12px' }}>{registerError.email}</p>
                        )}
                    </div>
                    <button className="btn-mm--primary w-100" type="submit" disabled={isProcessing}>Lanjut</button>
                </form>
            </div>
        </div>
    );

    // MODAL FORM REGISTRASI
    if (openModal == 3) return (
        <div className="modal-login-register position-fixed w-100 h-100 top-50">
            <div className="wrapper position-fixed w-100 top-50 bg-light p-4 text-center">
                <p onClick={openRegister} className="position-fixed fs-2 me-3 mt-2">
                    <img className="me-1" src="/images/Vector.png" alt="back" />
                </p>
                <h4 className="mt-1 mb-1">Daftar</h4>
                <p className="label-email m-0 mb-3">{registerData.email}</p>
                <form method="POST" onSubmit={submitRegister}>
                    <div className="mb-3 text-start">
                        <label className="form-label">Nama Lengkap</label>
                        <input type="text"
                            className="form-control"
                            value={registerData.name}
                            onChange={e => {
                                setRegisterError('name', '');
                                setRegisterData('name', e.target.value);
                            }}
                            required
                            autoFocus
                        />
                        {registerError.name && (
                            <div className="mt-1 text-danger" style={{ fontSize: '12px' }}>{registerError.name[0]}</div>
                        )}
                    </div>
                    <div className="mb-3 text-start">
                        <label className="form-label">Pekerjaan</label>
                        <input type="text"
                            className="form-control"
                            value={registerData.pekerjaan}
                            onChange={e => {
                                setRegisterError('pekerjaan', '');
                                setRegisterData('pekerjaan', e.target.value);
                            }}
                            required
                        />
                        {registerError.pekerjaan && (
                            <div className="mt-1 text-danger" style={{ fontSize: '12px' }}>{registerError.pekerjaan[0]}</div>
                        )}
                    </div>
                    <div className="mb-3 text-start">
                        <label className="form-label">Tanggal Lahir</label>
                        <input type="date"
                            className="form-control"
                            value={registerData.tgl_lahir}
                            onChange={e => {
                                setRegisterError('tgl_lahir', '');
                                setRegisterData('tgl_lahir', e.target.value);
                            }}
                            required
                        />
                        {registerError.tgl_lahir && (
                            <div className="mt-1 text-danger" style={{ fontSize: '12px' }}>{registerError.tgl_lahir[0]}</div>
                        )}
                    </div>
                    <div className="mb-3 text-start">
                        <label className="form-label">Password</label>
                        <div className="position-relative">
                            <input type={isPasswordVisible ? "text" : "password"}
                                className="form-control"
                                value={registerData.password}
                                onChange={e => {
                                    setRegisterError('password', '');
                                    setRegisterData('password', e.target.value);
                                }}
                                required
                            />
                            <span className="img2">
                                <img src={`/images/icon/${isPasswordVisible ? "show" : "hide"}-eye.png`}
                                    onClick={() => setIsPasswordVisible(prev => !prev)}
                                    alt={`${isPasswordVisible ? "show" : "hide"} password`} />
                            </span>
                        </div>
                        {registerError.password && (
                            <div className="mt-1 text-danger" style={{ fontSize: '12px' }}>{registerError.password[0]}</div>
                        )}
                    </div>
                    <p className="m-0 text-start">Dengan mendaftar, saya menyetujui</p>
                    <div className="d-flex gap-1 mb-2">
                        <a href="/privacy-policy" target="_blank">Syarat dan Ketentuan</a> yang berlaku.
                    </div>
                    <button className="btn-mm--primary w-100" type="submit" disabled={isProcessing}>{isProcessing ? "Memproses..." : "Daftar"}</button>
                </form>
            </div>
        </div>
    );
};

export default ModalLoginAndRegister;